import { ActiveDirectoryUserAttribute } from '../model/active-directory-user-attribute';

export class ActiveDirectoryUserAttributeMapper {
  public static map(data: any): ActiveDirectoryUserAttribute {
    return data ? new ActiveDirectoryUserAttribute(data.name, data.userAttributes) : null;
  }
}
